'use client';

import React from 'react';

import ErrorState from '@/app/(main)/_components/error-state/error-state';
import { captureBoundaryError } from '@/logger/boundary.client';

interface ErrorBoundaryState {
  hasError: boolean;
}

interface ErrorBoundaryProps {
  errorMessage: string;
  fallback?: React.ReactNode;
};

export class ErrorBoundary extends React.Component<React.PropsWithChildren<ErrorBoundaryProps>, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    captureBoundaryError('boundary.component', error, {
      componentStack: info.componentStack ?? undefined,
      label: this.props.errorMessage,
    });
  }

  render() {
    if (this.state.hasError) {
      if (this.props?.fallback) {
        return this.props.fallback;
      }

      return (
        <ErrorState onReset={() => window?.location?.reload()} />
      );
    }
    return this.props.children;
  }
}
